<tp-modal dialogTitle="Clone {{ data.cluster.id }}" [isBusy]="isSubmitting$ | async">
  @if (price$ | async; as price) {
    <p class="modal-content-wrapper">
      Would you like to clone '{{ data.cluster.id }}', creating a new cluster with the same specifications and data as this one?
    </p>

    @if (price.running.thousandthCentsPerHour != 0) {
      <div class="modal-content-wrapper info-block">
        <i class="fa-solid fa-circle-info"></i>
        <p>
          The new cluster will cost <strong>{{ runningPriceString(price) }}</strong> while running.
        </p>
      </div>
    }
  } @else {
    <tp-spinner/>
  }
  <tp-form-actions
    submitText="Clone" submitButtonStyle="primary-outline green stroke"
    buttonIdPrefix="cloneModal" [submitDisabled]="!(price$ | async)"
    [isSubmitting]="isSubmitting$ | async" (submitClick)="confirm()" [cancellable]="true" (cancel)="close()"
  />
</tp-modal>
